module.exports = __webpack_public_path__ + "img/icons8-speedometer.6023a966.svg";